"use strict";

exports.__esModule = true;

var _getCurrentLocale = require("./getCurrentLocale");

exports.getCurrentLocale = _getCurrentLocale.getCurrentLocale;

var _getLocalizedStringSchema = require("./getLocalizedStringSchema");

exports.getLocalizedStringSchema = _getLocalizedStringSchema.getLocalizedStringSchema;

var _getLocalizedStringFormData = require("./getLocalizedStringFormData");

exports.getLocalizedStringFormData = _getLocalizedStringFormData.getLocalizedStringFormData;

var _getLocalizedStringField = require("./getLocalizedStringField");

exports.getLocalizedStringField = _getLocalizedStringField.getLocalizedStringField;